import PageHeader from "@/components/PageHeader";
import { PATH_ROOT } from "@/constants";
import { ContractorsAssignmentsForm } from "@/modules/projects/components/contractors-assignments/components/ContractorsAssignmentsForm";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { ContractorsAssignmentsAddDialog } from "./ContractorsAssignmentsAddDialog";
import { ContractorsAssignmentsContextProvider } from "./ContractorsAssignmentsContext";

export const ContractorsAssignmentsDepartmentBasedDirectory = memo(() => {
  const { t } = useTranslation();

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: t("breadcrumb.home"), href: PATH_ROOT },
    {
      label: t("projects.breadcrumb.departmentBasedContractorsAssignments"),
    },
  ];

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <ContractorsAssignmentsContextProvider>
        <ContractorsAssignmentsForm />
        <ContractorsAssignmentsAddDialog />
      </ContractorsAssignmentsContextProvider>
    </>
  );
});
